// extracted by mini-css-extract-plugin
module.exports = {"Spacer--medium":"Spacer--medium--2vu9y","Spacer--large":"Spacer--large--3HctI"};